import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const categoryService = {
    getAll: () => api.get('/categories').then(res => res.data),
    create: (data) => api.post('/categories', data).then(res => res.data),
    update: (id, data) => api.put(`/categories/${id}`, data).then(res => res.data),
    delete: (id) => api.delete(`/categories/${id}`).then(res => res.data),
};

export const productService = {
    getAll: () => api.get('/products').then(res => res.data),
    getFeatured: (brandId) => api.get(`/products/featured/${brandId}`).then(res => res.data),
    create: (data) => api.post('/products', data).then(res => res.data),
    update: (id, data) => api.put(`/products/${id}`, data).then(res => res.data),
    delete: (id) => api.delete(`/products/${id}`).then(res => res.data),
    toggleFeatured: (id) => api.put(`/products/${id}/toggle-featured`).then(res => res.data),
};

export const kartelaService = {
    getAll: () => api.get('/kartelas').then(res => res.data),
    create: (data) => api.post('/kartelas', data).then(res => res.data),
    update: (id, data) => api.put(`/kartelas/${id}`, data).then(res => res.data),
    delete: (id) => api.delete(`/kartelas/${id}`).then(res => res.data),
};

export const aiService = {
    parseProduct: (text) => api.post('/ai/parse-product', { text }).then(res => res.data),
};

export const settingsService = {
    getAll: () => api.get('/settings').then(res => res.data),
    update: (data) => api.put('/settings', data).then(res => res.data),
};

export const dealerService = {
    getAll: (brandId) => api.get('/dealers', { params: brandId ? { brandId } : {} }).then(res => res.data),
    getById: (id) => api.get(`/dealers/${id}`).then(res => res.data),
    create: (data) => api.post('/dealers', data).then(res => res.data),
    update: (id, data) => api.put(`/dealers/${id}`, data).then(res => res.data),
    delete: (id) => api.delete(`/dealers/${id}`).then(res => res.data),
};

export const articleService = {
    getAll: (brandId) => api.get('/articles', { params: brandId ? { brandId } : {} }).then(res => res.data),
    getById: (id) => api.get(`/articles/${id}`).then(res => res.data),
    getBySlug: (slug) => api.get(`/articles/slug/${slug}`).then(res => res.data),
    create: (data) => api.post('/articles', data).then(res => res.data),
    update: (id, data) => api.put(`/articles/${id}`, data).then(res => res.data),
    delete: (id) => api.delete(`/articles/${id}`).then(res => res.data),
};

export default api;
